import { render, staticRenderFns } from "./PersonEdit.vue?vue&type=template&id=1089ce88&"
import script from "./PersonEdit.vue?vue&type=script&lang=js&"
export * from "./PersonEdit.vue?vue&type=script&lang=js&"
import style0 from "./PersonEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports